'use client';

import { useState } from "react";
import RegistrationContainer from "../auth/registration_container";
import classes from "./login_modal_registration.module.css";

export default function LoginModalRegistration({}) {
    const [success, setSucces] = useState(false);

    return <>
        <RegistrationContainer success={success} setSucces={setSucces} is_modal />
    </>
}